export const api_url = window.location.hostname.includes("howtoclimb513.com")
  ? "https://api.howtoclimb513.com/webapi"
  : "http://localhost:8000/webapi";
// api_url: "http://localhost:8000"
// api_url: "https://api.ascensionapp.com"

export const version = "0.0.5";
